<template>
  <b-form-group
    label="Alt Başlık"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Alt Başlık"
      rules="required"
    >
      <b-form-input
        id="subtitle"
        v-model="dataItem.subtitle"
        placeholder="AltBaşlık"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'LabSubTitle',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['laboratory/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
